<template>
  <div class="container-layout" :class="{ 'small-container': isSmallContainer }">
    <project-header :project="project">
      <div class="donate-button-header">
        <cs-button type="secondary" @click="$emit('donate')">
          <div class="project-donate">
            <span class="icon icon-donate"></span>
            <span class="text-donate">Поддержать</span>
          </div>
        </cs-button>
      </div>
    </project-header>

    <div v-if="isLoaded" class="bills-layout">
      <masonry grid-gap="20px" :col-width="columnWidth" :items="catalog.items">
        <bill-card v-for="bill in catalog.items" :bill="bill" :key="bill.id" @click="onClick" />
      </masonry>
    </div>

    <div class="donate-button-footer">
      <cs-button type="secondary" @click="$emit('donate')">
        <div class="project-donate">
          <span class="icon icon-donate"></span>
          <span class="text-donate">Поддержать</span>
        </div>
      </cs-button>
    </div>

    <base-footer />
  </div>
</template>

<script>
import { isMobile, isTablet } from 'mobile-device-detect';

import serializeParams from '@/lib/utils/url';
import HTTPService from '@/services/Http';

import Masonry from '@/components/Masonry';

import BaseFooter from 'molecules/base/BaseFooter';
import BillCard from 'organisms/project/BillCard';
import ProjectHeader from 'organisms/project/ProjectHeader';

export default {
  name: 'MarketplaceBills',
  components: {
    Masonry,
    BaseFooter,
    BillCard,
    ProjectHeader,
  },
  props: {
    project: {
      type: Object,
      required: true,
    },
  },
  async created() {
    await this.loadBills();

    this.calcScroll();
  },
  mounted() {
    window.addEventListener('scroll', this.onScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll);
  },
  data() {
    return {
      catalog: {
        items: [],
        lastDataChunk: [],
        countPerPage: 0,
        internalOffset: 0,
        loading: false,
      },
      documentHeight: 0,
      documentOffset: 0,
      isMobile,
      isTablet,
    };
  },
  computed: {
    isLoaded() {
      return this.$validate.isNotEmptyArray(this.catalog.items);
    },
    isSmallContainer() {
      return this.catalog.items.length <= 2;
    },
    columnWidth() {
      if (this.isTablet) {
        return 'minmax(Min(12em, 100%), 1fr)';
      }

      return this.isMobile ? 'minmax(Min(28vw, 100%), 1fr)' : '220px';
    },
    donateCard() {
      return {
        isDonate: true,
        billTariffs: [],
        projectLogoLink: this.project.project_logo,
        projectName: this.project.project_name,
      };
    },
  },
  methods: {
    calcScroll() {
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset || 0;

      this.documentOffset = scrollTop + window.innerHeight + 20;
      this.documentHeight = document.documentElement.offsetHeight;
    },
    getPayload() {
      const getParams = Object.assign({},
        { projectId: this.project.project_id },
        { internalOffset: this.catalog.internalOffset }
      );

      return serializeParams(getParams);
    },
    async loadBills() {
      const payload = this.getPayload();

      this.loading = true;

      try {
        const { data } = await HTTPService.fetchMarketplaceBills(payload);

        this.catalog.items.push(...data.result);
        this.catalog.lastDataChunk = data.result;
        this.catalog.countPerPage = data.countPerPage;
        this.catalog.internalOffset = data.internalOffset;

        this.catalog.items.push(this.donateCard);
      } catch (error) {
        this.catalog.items = [this.donateCard];
      }

      this.loading = false;
    },
    onClick(bill) {
      const { payLink } = bill;

      if (this.$validate.isUndefined(payLink)) {
        this.$emit('donate');
        return;
      }

      window.open(payLink, '_blank');
    },
    async onScroll() {
      this.calcScroll();

      if (this.loading) {
        return;
      }

      if (this.catalog.lastDataChunk.length < this.catalog.countPerPage) {
        return;
      }

      if (this.documentOffset >= this.documentHeight) {
        await this.loadBills();
      }
    },
  },
};
</script>

<style lang="sass" scoped>
  .container-layout
    width: 100%
    max-width: 740px
    margin: 0 auto 40px
    padding: 0 20px

    @media screen and (max-width: 740px)
      max-width: 500px

    &.small-container
      max-width: 500px

  .bills-layout
    width: 100%
    margin: 0 auto
    padding-bottom: 30px

  .donate-button-footer
    display: none
    margin-bottom: 30px
    text-align: center

  @media screen and (max-width: 320px)
    .donate-button-header
      display: none

    .donate-button-footer
      display: block

  @media screen and (min-width: 321px) and (max-width: 570px)
    .donate-button-header
      display: none

    .donate-button-footer
      display: block

  .icon
    width: 22px
    height: 22px
    background-position: center
    background-repeat: no-repeat
    background-size: auto

  .icon-donate
    width: 20px
    height: 20px
    background-image: url('~@/assets/svg/donate.svg')

  .project-donate
    display: flex
    align-items: center
    padding: 0 5px 0 7px

  .text-donate
    margin-left: 5px
    line-height: 17px
</style>
